import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Home } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_secure-parcels/artifacts/gsdtwsrt_ISOTIPO.png";

export const CTASection = () => {
  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Background with Logo Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32">
          <img src={LOGO_ICON} alt="" className="w-full h-full" />
        </div>
        <div className="absolute bottom-20 right-20 w-48 h-48">
          <img src={LOGO_ICON} alt="" className="w-full h-full" />
        </div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24">
          <img src={LOGO_ICON} alt="" className="w-full h-full" />
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-lokker-lime text-black text-sm font-bold px-4 py-2 rounded-sm mb-6 uppercase tracking-wide">
            Soluções B2B
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-4">
            Use Lokker para seu negócio
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Soluções personalizadas para condomínios e empresas que querem inovar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Condomínios Card */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            data-testid="cta-condominios-card"
            className="bg-white p-8 rounded-sm card-hover border-t-4 border-lokker-lime"
          >
            <div className="w-14 h-14 bg-lokker-blue rounded-sm flex items-center justify-center mb-6">
              <Home className="w-7 h-7 text-lokker-lime" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-slate-900 mb-3">
              Para Condomínios
            </h3>
            <p className="text-slate-600 mb-6 leading-relaxed">
              Reduza o trabalho da portaria, aumente a segurança e ofereça mais praticidade aos moradores.
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Modelo de assinatura para condomínios
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Instalação e manutenção incluídas
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Gestão simplificada para síndicos
              </li>
            </ul>
            <Link to="/condominios">
              <Button
                data-testid="cta-condominios-button"
                className="w-full bg-lokker-blue text-white font-bold py-4 rounded-sm flex items-center justify-center gap-2 hover:bg-lokker-blue-dark transition-colors"
              >
                Solicitar Proposta
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </motion.div>

          {/* Empresas Card */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            data-testid="cta-empresas-card"
            className="bg-white p-8 rounded-sm card-hover border-t-4 border-lokker-blue"
          >
            <div className="w-14 h-14 bg-lokker-lime rounded-sm flex items-center justify-center mb-6">
              <Building2 className="w-7 h-7 text-black" />
            </div>
            <h3 className="font-heading font-bold text-2xl text-slate-900 mb-3">
              Para Empresas
            </h3>
            <p className="text-slate-600 mb-6 leading-relaxed">
              Ofereça um diferencial competitivo e atraia mais clientes com lockers inteligentes.
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Ideal para shoppings e academias
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Aumente o fluxo de clientes
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-600">
                <div className="w-1.5 h-1.5 bg-lokker-blue rounded-full" />
                Modelos flexíveis de parceria
              </li>
            </ul>
            <Link to="/empresas">
              <Button
                data-testid="cta-empresas-button"
                className="w-full bg-lokker-lime text-black font-bold py-4 rounded-sm flex items-center justify-center gap-2 hover:bg-lokker-lime-dark transition-colors"
              >
                Quero no Meu Negócio
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
